"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("@/api/config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfigMall',
  data: function data() {
    return {
      dataForm: {
        litemall_mall_name: '',
        litemall_mall_address: '',
        litemall_mall_phone: '',
        litemall_mall_qq: '',
        litemall_mall_longitude: '',
        litemall_mall_latitude: ''
      },
      rules: {
        litemall_mall_name: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        litemall_mall_address: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        litemall_mall_phone: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        litemall_mall_qq: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      (0, _config.listMall)().then(function (response) {
        _this.dataForm = response.data.data;
      });
    },
    cancel: function cancel() {
      this.init();
    },
    update: function update() {
      var _this2 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.doUpdate();
      });
    },
    doUpdate: function doUpdate() {
      var _this3 = this;
      (0, _config.updateMall)(this.dataForm).then(function (response) {
        _this3.$notify.success({
          title: '成功',
          message: '商场配置成功'
        });
      }).catch(function (response) {
        _this3.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    }
  }
};